import { render, staticRenderFns } from "./component-order-detaile-ai-certificate-verification.vue?vue&type=template&id=b9a91018&scoped=true"
import script from "./component-order-detaile-ai-certificate-verification.vue?vue&type=script&lang=js"
export * from "./component-order-detaile-ai-certificate-verification.vue?vue&type=script&lang=js"
import style0 from "./component-order-detaile-ai-certificate-verification.vue?vue&type=style&index=0&id=b9a91018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a91018",
  null
  
)

export default component.exports